import React from 'react'
import { hugeiconShapes, HugeiconKey } from './hugeicons'

type Props = {
  name: HugeiconKey
  className?: string
  style?: React.CSSProperties
  // Width and height; 1em by default, so the icon follows the surrounding font size.
  size?: number | string
  title?: string
}

// A Hugeicon in the CivicLift-wide style, drawn in currentColor: its color comes from the CSS
// color around it, its size from the font size (or `size`). Draws nothing for an icon the page
// doesn't carry.
export const Hugeicon: React.FC<Props> = ({ name, className, style, size = '1em', title }) => {
  const shapes = hugeiconShapes(name)
  if (shapes === null) return null
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      aria-hidden={title ? undefined : 'true'}
      role={title ? 'img' : undefined}
      aria-label={title}
      focusable="false"
      className={className}
      style={style}
      dangerouslySetInnerHTML={{ __html: shapes }}
    />
  )
}

export default Hugeicon
